export default __webpack_public_path__ + "../staticImages/rotwein-nl-img.jpg";